export default __webpack_public_path__ + "static/media/info-icon.eef5e305.svg";